import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { Button, Modal, Mo } from 'nallian-shared-ui/lib/components';
import RemoveOrganisationContactService from '../../services/contacts/removeOrganisationContactService';

const RemoveContact = ({
  organisationId,
  contactId,
  open,
  returnRoute,
  removeOrganisationContactFetch,
  dispatchRemoveOrganisationContactDelete,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleGoBack = useCallback(() => navigate(returnRoute), [returnRoute, navigate]);

  const handleRemove = useCallback(() => {
    dispatchRemoveOrganisationContactDelete(organisationId, contactId, handleGoBack, t);
  }, [dispatchRemoveOrganisationContactDelete, handleGoBack, organisationId, contactId, t]);

  if (!open) return null;

  return (
    <Modal open basic size="tiny">
      <Mo.Header>{t('areYouSureYouWantToRemoveContact')}</Mo.Header>
      <Mo.Actions>
        <Button
          inverted
          content={t('cancel')}
          onClick={handleGoBack}
          disabled={removeOrganisationContactFetch.pending}
        />
        <Button
          primary
          inverted
          content={t('confirm')}
          onClick={handleRemove}
          loading={removeOrganisationContactFetch.pending}
          disabled={removeOrganisationContactFetch.pending}
        />
      </Mo.Actions>
    </Modal>
  );
};

RemoveContact.propTypes = {
  dispatchRemoveOrganisationContactDelete: PropTypes.func.isRequired,
  removeOrganisationContactFetch: PropTypes.object.isRequired,
  organisationId: PropTypes.string.isRequired,
  contactId: PropTypes.string.isRequired,
  returnRoute: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
};

export default RemoveOrganisationContactService(RemoveContact);
